<template>
    <div class="chat-body">
        <chat-old 
            :chatId="chatId"></chat-old>
    </div>
</template>
<script>
export default {
    components: {
        Chat
    },
    data(){
        return{
            projectConfigs : {
                apiKey: process.env.VUE_APP_CHAT_apiKey,
                authDomain: process.env.VUE_APP_CHAT_authDomain,
                databaseURL: process.env.VUE_APP_CHAT_databaseURL,
                projectId: process.env.VUE_APP_CHAT_projectId,
                storageBucket: process.env.VUE_APP_CHAT_storageBucket,
                messagingSenderId: process.env.VUE_APP_CHAT_messagingSenderId
            },
            chatId : '',
            collectionName : 'teamGames',
            dataPlayer : ''
        }
    },
    async created(){
        this.dataPlayer = this.$store.getters.getSimple(['group', 'selfPlayer', 'chatId'])
        this.chatId = this.dataPlayer.chatId
    },
    methods:{
        async chatIds(chatIds){
            let letter = this.$route.params.letter
            let chatLetter = chatIds.filter(chat => {
                return chat.title == letter
            })
            return chatLetter[0].id
        }
    }
}
</script>
<style lang="scss" scoped>
    @media only screen and (min-width: 750px){
        .chat-body{
            height: 100%;
        }
    }
    

</style>
